import { ISELevels } from '@astrid/components'

export const IseLevelLabels: Record<ISELevels, string> = {
  [ISELevels.A1]: 'A1',
  [ISELevels.Foundation]: 'Foundation',
  [ISELevels.Ise1]: 'ISE I',
  [ISELevels.Ise2]: 'ISE II'
}
